import { Component, OnInit } from '@angular/core';
import { LeadService } from '../../../../../../shared/store/lead/lead.service';
import { Observable } from 'rxjs';
import { LeadDetailModel } from '../../../../../../shared/store/lead/types';
import { SubHeaderService } from '../../../../../../shared/store/subheader/subheader.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ModalContentComponent } from '../../../../../../shared/components/modal-content/modal-content.component';
import { SourceEnum } from '../../../../../../shared/store/typeahead/types';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from '../../../../../../shared/service/modal.service';
import { ActivatedRoute } from '@angular/router';
import { ModalComponentKey } from '../../../../../../shared/service/modal-component';

@UntilDestroy()
@Component({
  selector: 'app-lead-details-duplicates',
  templateUrl: './lead-details-duplicates.component.html',
  styleUrl: './lead-details-duplicates.component.scss',
  standalone: false,
})
export class LeadDetailsDuplicatesComponent implements OnInit {
  lead$: Observable<LeadDetailModel>;

  constructor(
    private readonly leadService: LeadService,
    private readonly subHeaderService: SubHeaderService,
    private readonly modalService: NgbModal,
    private readonly modalExchangeService: ModalService,
    private readonly route: ActivatedRoute,
  ) {
    this.lead$ = this.leadService.getByUniqueId.value$;
  }

  ngOnInit(): void {
    this.subHeaderService
      .getTriggerAction()
      .pipe(untilDestroyed(this))
      .subscribe((x) => {
        if (x == 'leadDuplicatesSetAsDuplicates') {
          this.openModelToSetDuplicates();
        }
        this.subHeaderService.setTriggerAction('');
      });
  }

  private openModelToSetDuplicates() {
    const modalRef = this.modalService.open(ModalContentComponent, {
      size: 'xl',
      backdrop: 'static',
      modalDialogClass: 'modal-xxl',
    });

    modalRef.componentInstance.component =
      this.modalExchangeService.getComponentClass(
        ModalComponentKey.LeadSetAsDuplicatesContentComponent,
      );
    modalRef.componentInstance.title =
      'LEAD_LBL_DUPLICATES_MARK_AS_DUPLICATE_TITLE';
    modalRef.componentInstance.cancelButton = false;
    modalRef.componentInstance.buttons = [];
    modalRef.componentInstance.inputParams = {
      source: SourceEnum.Modal,
      leadUniqueId: this.route.snapshot.params['uniqueId'],
    };

    // The lead refresh comes from the markAsDuplicate effect; a dismiss rejects the result.
    modalRef.result.catch(() => {});
  }
}
